import axios from 'axios';
import { showAlert } from '../components/UIElements/AlertService';
//import { logout } from '../utils/logout';
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

api.interceptors.request.use((config) => {
  // attach auth token if needed
  //config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
  return config;
});

api.interceptors.request.use((config) => {
  const user = localStorage.getItem('userName');
  const access_token = localStorage.getItem('access_token');
  const startDate = localStorage.getItem('startDate');
  const endDate = localStorage.getItem('endDate');
  config.headers['startDate'] = startDate;
  config.headers['endDate'] = endDate;
  config.headers['Authorization'] =
    config.headers['Authorization'] ?? 'Bearer ' + access_token;
  if (user) {
    config.headers['user'] = user;
  } else {
    delete config.headers['user'];
  }

  // Add auth token if needed
  // config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;

  return config;
});

api.interceptors.response.use(
  (response) => {
    // Check if the response is HTML (maintenance page)
    if (response.headers['content-type']?.includes('text/html')) {
      // Return structured error for maintenance
      console.log(
        'server is not Responding.Server is under maintenance process .',
      );
      showAlert('⚠️ Server is unreachable. Please try again later.');
      return Promise.reject({
        response: {
          status: 503,
          data: 'Server in maintenance mode',
        },
      });
    }
    return response; // normal JSON response
  },
  (error) => {
    if (error.code === 'ERR_NETWORK') {
      showAlert('⚠️ Server is unreachable. Please try again later.');
    }
    console.error('API error:', error);
    // handle errors globally
    if (error?.response?.status === 401) {
      // redirect to login or show a message
      console.error('Unauthorized access - redirecting to login');
      alert('Session Timed out,Please login again!');
      window.location.replace('/signin');
      return;
    }
    return Promise.reject(error);
  },
);

export default api;
